class Filter {
	constructor(el) {
		this.el = el;
		this.title = el.querySelector('.category-theme');
		this.filters = el.querySelectorAll('.filter');
		this.content = el.querySelector('.content');
		this.arrow = el.querySelector('.arrow');
		this.selectedFilters = [];

		this.preselectFromQuery();

		this.animation = null;
		this.isClosing = false;
		this.isExpanding = false;

		this.title.addEventListener('click', (e) => this.onClick(e));
		this.filters.forEach((filter) => {
			filter.addEventListener('click', (e) => this.onSelectFilter(e));
		});

		// Set initial open/close state based on active filters
		this.setInitialOpenState();
	}

	setInitialOpenState() {
		try {
			if (this.selectedFilters && this.selectedFilters.length > 0) {
				this.el.open = true;
				if (this.arrow) this.arrow.style.transform = 'rotate(90deg)';
			} else {
				this.el.open = false;
				if (this.arrow) this.arrow.style.transform = 'rotate(0deg)';
			}
			// Clear inline styles to avoid stuck heights
			this.el.style.height = '';
			this.el.style.overflow = '';
		} catch (e) {
			// fail silently
		}
	}

	onSelectFilter(e) {
		const selectedFilter = e.target.classList[1];
		if (!selectedFilter) return;
		if (e.target.classList.contains('thisFilter')) {
			// Deselect if already selected
			e.target.classList.remove('thisFilter');
			this.selectedFilters = this.selectedFilters.filter((item) => item !== selectedFilter);
		} else {
			// Select if not selected
			e.target.classList.add('thisFilter');
			if (!this.selectedFilters.includes(selectedFilter)) {
				this.selectedFilters.push(selectedFilter);
			}
		}
	}

	returningFilter() {
		const title = this.title.querySelector('strong').innerText;
		return {
			name: title,
			filters: this.selectedFilters,
		};
	}

	resetFilters() {
		this.filters.forEach((filter) => filter.classList.remove('thisFilter'));
		this.selectedFilters = [];
	}

	onClick(e) {
		e.preventDefault();
		this.el.style.overflow = 'hidden';
		if (this.isClosing || !this.el.open) {
			this.open();
		} else if (this.isExpanding || this.el.open) {
			this.shrink();
		}
	}

	shrink() {
		this.el.style.overflow = 'hidden';
		this.arrow.style.transform = 'rotate(0deg)';
		this.isClosing = true;

		const startHeight = `${this.el.offsetHeight}px`;
		const endHeight = `${this.title.offsetHeight}px`;

		if (this.animation) {
			this.animation.cancel();
		}

		this.animation = this.el.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 400,
				easing: 'ease-out',
			}
		);

		this.animation.onfinish = () => this.onAnimationFinish(false);
		this.animation.oncancel = () => (this.isClosing = false);
	}

	open() {
		this.el.style.height = `${this.el.offsetHeight}px`;
		this.arrow.style.transform = 'rotate(90deg)';

		this.el.open = true;

		window.requestAnimationFrame(() => this.expand());
	}

	expand() {
		this.isExpanding = true;
		const startHeight = `${this.title.offsetHeight}px`;
		const endHeight = `${this.title.offsetHeight + this.content.offsetHeight}px`;

		if (this.animation) {
			this.animation.cancel();
		}

		this.animation = this.el.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 400,
				easing: 'ease-out',
			}
		);
		this.animation.onfinish = () => this.onAnimationFinish(true);
		this.animation.oncancel = () => (this.isExpanding = false);
	}

	onAnimationFinish(open) {
		this.el.open = open;
		this.animation = null;
		this.isClosing = false;
		this.isExpanding = false;
		this.el.style.height = this.el.style.overflow = '';
	}

	preselectFromQuery() {
		try {
			const params = new URLSearchParams(window.location.search);
			if (!params || Array.from(params.keys()).length === 0) return;

			const rawTitle = this.title?.querySelector('strong')?.innerText || '';
			if (!rawTitle) return;
			const titleSlug = rawTitle
				.trim()
				.toLowerCase()
				.normalize('NFD')
				.replace(/\p{Diacritic}/gu, '')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '');

			const aliasMap = {
				'destination': ['destination', 'destinations'],
				'destinations': ['destination', 'destinations'],
				'age': ['age', 'ages'],
				'ages': ['age', 'ages'],
				'ecole': ['ecole', 'ecoles'],
				'ecoles': ['ecole', 'ecoles'],
				'periode': ['periode', 'periodes'],
				'periodes': ['periode', 'periodes'],
				'sejour-long': [
					'sejour-long',
					'sejours-longs',
					'sejour-longue',
					'sejours-long',
				],
				'sejours-longs': [
					'sejour-long',
					'sejours-longs',
					'sejour-longue',
					'sejours-long',
				],
				'sejour-court': ['sejour-court', 'sejours-courts'],
				'sejours-courts': ['sejour-court', 'sejours-courts'],
			};
			const possibleKeys = aliasMap[titleSlug] || [titleSlug, titleSlug + 's'];

			let matchedKey = null;
			for (const k of params.keys()) {
				const keySlug = String(k)
					.trim()
					.toLowerCase()
					.normalize('NFD')
					.replace(/\p{Diacritic}/gu, '')
					.replace(/[^a-z0-9]+/g, '-')
					.replace(/^-+|-+$/g, '');
				if (possibleKeys.includes(keySlug)) {
					matchedKey = k;
					break;
				}
			}
			if (!matchedKey) return;

			const values = params.get(matchedKey)?.split(',').filter(Boolean) || [];
			if (values.length === 0) return;

			this.filters.forEach((filterEl) => {
				const cls = Array.from(filterEl.classList).find((c) => c !== 'filter');
				if (cls && values.includes(cls)) {
					filterEl.classList.add('thisFilter');
					this.selectedFilters.push(cls);
				}
			});
			this.selectedFilters = this.selectedFilters.filter(
				(item, idx, arr) => arr.indexOf(item) === idx
			);
		} catch (e) {
			console.error('Error parsing URL parameters for filter preselection:', e);
		}
	}
}

export { Filter };
